import { CHCHeader } from "./header.component.js";
customElements.define("chc-header", CHCHeader);
export {
  CHCHeader
};
//# sourceMappingURL=header.js.map
